import { Component, Input } from '@angular/core';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-checked-icon',
    template: `
        <div class="no-icon" *ngIf="!checked"></div>
        <mat-icon *ngIf="checked">check</mat-icon>
    `,
    styles: [ `
        .no-icon {
            display: inline-block;
            height: 24px;
            width: 24px;
            margin-right: 16px;
        }
    ` ]
})
export class CheckedIconComponent  {
    @Input() checked: boolean;
}
